import { CategoryModelModule } from './category.model';
import { CustomerModelModule } from './customer.model';
import { DiscountsModelModule } from './discounts.model';
import { FulfillerModelModule } from './fulfiller.model';
import { ImageMetadataModelModule } from './imageMetadata.model';
import { OrderModelModule } from './orders.model';
import { PagesModelModule } from './pages.model';
import { PostageDefaultsModelModule } from './postageDefaults.model';
import { ProductsModelModule } from './products.model';
import { ShippingMethodsModelModule } from './shippingMethods.model';
import { StoreInformationModelModule } from './storeInformation.model';
import { ThemeStylesModelModule } from './themeStyles.model';
import { UserModelModule } from './user.model';
import { VariantModelModule } from './variant.model';
import { AddressModelModule } from './address.model';
import { VolusionPaymentsKYCModelModule } from './volusionPaymentsKYC.model';

export const ModelsModule = angular
    .module('app.components.model.models', [
        AddressModelModule,
        CategoryModelModule,
        CustomerModelModule,
        DiscountsModelModule,
        FulfillerModelModule,
        ImageMetadataModelModule,
        OrderModelModule,
        PagesModelModule,
        PostageDefaultsModelModule,
        ProductsModelModule,
        ShippingMethodsModelModule,
        StoreInformationModelModule,
        ThemeStylesModelModule,
        UserModelModule,
        VariantModelModule,
        VolusionPaymentsKYCModelModule
    ]).name;



// WEBPACK FOOTER //
// ./src/app/services/data/model/models/models.module.js